import axios from 'axios'

export default {
  list(params) {
    return axios.get('/tasks', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  get(id) {
    return axios.get('/tasks/' + id).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  save(data) {
    return axios.post('/tasks', data).then(response => {
      return { success: true, data: response.data.entity }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  delete(id) {
    return axios.post('/tasks/' + id + '/delete').then(() => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  forceDelete(id) {
    return axios.post('/tasks/' + id + '/delete/force').then(() => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  restore(id) {
    return axios.post('/tasks/' + id + '/restore').then(() => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  attach(toAttachableId, attachableId) {
    return axios.post('/tasks/' + toAttachableId + '/attach', { task_id: attachableId }).then(() => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  detach(fromDetachableId, detachableId) {
    return axios.post('/tasks/' + fromDetachableId + '/detach', { task_id: detachableId }).then(() => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
